import formatAbsoluteUrl from '@utils/formatters/absolute-url';

interface TradeCardSEOProps {
  tradeProfileUrl: string;
  operatingLocationText: string;
  telephoneNumber?: string;
  logoUrl: string;
  locality?: string;
  addDescription?: boolean;
  description?: string;
}

export const TradeCardCoreSEO = ({
  telephoneNumber,
  locality,
  logoUrl,
  tradeProfileUrl,
  operatingLocationText,
  addDescription = false,
  description = '',
}: TradeCardSEOProps) => {
  // When using this component - ensure that it's within a
  // `itemScope` and `itemType` wrapped div
  return (
    <>
      <meta itemProp="url" content={formatAbsoluteUrl(tradeProfileUrl)} />
      <meta itemProp="areaServed" content={operatingLocationText} />
      <meta itemProp="currenciesAccepted" content="GBP" />
      <meta itemProp="memberOf" content={formatAbsoluteUrl()} />
      <meta itemProp="telephone" content={telephoneNumber} />
      <meta itemProp="logo" content={logoUrl} />
      <meta itemProp="location" content={locality} />
      {addDescription && <meta itemProp="description" content={description} />}
    </>
  );
};
